var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterAz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#131515",
    d: "m1.795.5-.11.328L.718 3.5H.701v.031l-.5 1.375V5.5h1v-.422l.204-.578h1.593l.203.578V5.5h1v-.594l-.5-1.375V3.5h-.015L2.717.828 2.607.5h-.812Zm6.906 0v9.344L7.405 8.547 6.7 9.25l2.141 2.156.36.344.359-.344L11.7 9.25l-.703-.703-1.297 1.297V.5h-1Zm-6.5 1.828L2.623 3.5H1.78L2.2 2.328Zm-2 4.172v1h2.782L.342 10.14l-.14.157V11.5h4v-1H1.42l2.64-2.64.141-.157V6.5h-4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterAz);
export default __webpack_public_path__ + "static/media/filterAZ.534099946b1057b9dddac13e8daf4e61.svg";
export { ForwardRef as ReactComponent };